export default __webpack_public_path__ + "static/media/Neck.e7a6d165.svg";